export default __webpack_public_path__ + "static/media/netlify-icon.e6ca3874.svg";